module.exports = __webpack_public_path__ + "static/media/eat.d3fcebaf.svg";